export class TrialSupportLink {
  public id: string;
  public trialId: string;
  public label: string;
  public url: string;
  public deleted: boolean;
  public translations: TrialSupportLinkTranslation[] = [];
  public countries: string;
  public allCountries: boolean;

  constructor(init?: Partial<TrialSupportLink>) {
    Object.assign(this, init);
  }
}

export class TrialSupportLinkTranslation {
  public id: string;
  public trialSupportLinkId: string;
  public culture: string;
  public label: string;

  constructor(init?: Partial<TrialSupportLinkTranslation>) {
    Object.assign(this, init);
  }
}
